import { Globe2, SlidersHorizontal, RefreshCw, Check } from "lucide-react";
import { Reveal, SectionLabel } from "../components/Reveal";

const SERVICES = [
  {
    icon: Globe2,
    number: "01",
    title: "Creazione siti web",
    text: "Siti vetrina professionali, responsive e progettati per rappresentare al meglio attività e professionisti.",
    listTitle: "Possibili contenuti",
    items: ["Attività", "Servizi", "Menu", "Listini", "Fotografie", "Orari", "Informazioni", "Posizione", "Contatti"],
  },
  {
    icon: SlidersHorizontal,
    number: "02",
    title: "Funzionalità su misura",
    text: "In base al tipo di attività possono essere integrate funzionalità come:",
    items: [
      "Prenotazioni e appuntamenti",
      "Richieste di preventivo e moduli di contatto",
      "Telefono, email e WhatsApp",
      "Menu, listini e gallerie",
      "Google Maps e collegamenti social",
      "Altre funzionalità concordate",
    ],
    note: "Queste sono possibilità: ogni funzionalità viene valutata e concordata in base al progetto.",
  },
  {
    icon: RefreshCw,
    number: "03",
    title: "Gestione e aggiornamenti",
    text: "Dopo la pubblicazione puoi richiedere a DS LAB STUDIO:",
    items: ["Modifiche", "Aggiornamenti", "Assistenza", "Gestione periodica del sito"],
    note: "Un servizio facoltativo, da valutare solo se e quando ti serve.",
  },
];

export const Services = () => (
  <section id="servizi" aria-labelledby="servizi-title" className="bg-mist">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="max-w-3xl">
        <SectionLabel>Servizi</SectionLabel>
        <h2 id="servizi-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-navy-dark sm:text-4xl">
          Un sito costruito intorno alla tua attività.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-steel sm:text-lg">
          Ogni attività ha esigenze diverse. Per questo struttura, contenuti e funzionalità vengono
          definiti in base al progetto e agli obiettivi del cliente.
        </p>
      </Reveal>
      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {SERVICES.map((service, i) => (
          <Reveal key={service.title} delay={i * 0.1} className="h-full">
            <article className="flex h-full flex-col rounded-xl border border-line bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-celeste hover:shadow-lg hover:shadow-navy/5">
              <div className="flex items-center justify-between">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-navy text-white" aria-hidden="true">
                  <service.icon className="h-5 w-5" />
                </span>
                <span className="font-display text-sm font-bold tracking-widest text-celeste" aria-hidden="true">
                  {service.number}
                </span>
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold text-navy-dark">{service.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-steel">{service.text}</p>
              {service.listTitle && (
                <p className="mt-4 text-xs font-semibold uppercase tracking-widest text-steel">{service.listTitle}</p>
              )}
              <ul className="mt-3 space-y-2">
                {service.items.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-navy-dark">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-celeste" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
              {service.note && (
                <p className="mt-auto pt-5 text-xs leading-relaxed text-steel/90">{service.note}</p>
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
